/**
 * Known / probable workflow types. Values are lowercase template keys
 * (e.g. "admission", "arbitration") so they match API + template naming.
 *
 * Templates may still introduce unknown keys — UI treats those as free-form
 * strings (humanized labels, hashed colors).
 */
export enum WorkflowType {
  ADMISSION = "admission",
  ADMISSION_CONTRACT = "admission_contract",
  READMISSION = "readmission",
  CONSENTS = "consents",
  ARBITRATION = "arbitration",
  DISPUTE_RESOLUTIONS = "dispute_resolutions",
  PRE_ADMISSION_DOCUMENTS = "pre_admission_documents",
  POST_ADMISSION_DOCUMENTS = "post_admission_documents",
  FINANCIAL_FORMS = "financial_forms",
  CLINICAL_FORMS = "clinical_forms",
}

export type WorkflowOption = Readonly<{
  /** Lowercase workflow type from the facility template (e.g. "admission", "arbitration"). */
  type: string;
  label: string;
}>;
